import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/unbounded';
import '@fontsource-variable/inter';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
// Стили MapLibre импортируются ЗДЕСЬ и обязательно ДО globals.css: иначе они
// попадают в бандл позже наших и перебивают оформление попапа своим белым фоном.
import 'maplibre-gl/dist/maplibre-gl.css';
import './styles/globals.css';
import { App } from './App';
import { initI18n } from './i18n';

const root = document.getElementById('root');
if (!root) throw new Error('нет узла #root');

// Интерфейс не показывается до готовности словаря: иначе игрок на долю секунды
// видит сырые ключи вида common.action.play.
void initI18n().then(() => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
